import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function fetchStoreCardConfig (cityId, storeId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString())
    const response = await axios.get(url)

    return response.data
}

async function fetchStoreRewards (cityId, storeId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString(), 'rewards')
    const response = await axios.get(url)

    return response.data
}

async function createStoreReward (token, cityId, storeId, reward)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString(), 'rewards')
    const response = await axios.post(url, reward, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function updateStoreReward (token, cityId, storeId, rewardId, reward)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString(), 'reward', rewardId.toString())
    const response = await axios.put(url, reward, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function deleteStoreReward (token, cityId, storeId, rewardId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString(), 'reward', rewardId.toString())
    const response = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function fetchStoreRewardHistory (cityId, storeId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString(), 'history', 'rewards')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function fetchStoreCreditHistory (cityId, storeId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-loyalty-cards', storeId.toString(), 'history', 'credits')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

export default { fetchStoreCardConfig, fetchStoreRewards, createStoreReward, updateStoreReward, deleteStoreReward, fetchStoreRewardHistory, fetchStoreCreditHistory }


// WEBPACK FOOTER //
// ./src/services/storeLoyaltyCard.js